import React, {useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {ModalTextAreaInput} from "../../form-components/ModalTextAreaInput";
import {TreatmentHoldInput} from "./TreatmentHoldFormModal";
import {useCurrentUser} from "../../../../security";

type Props = {
    sending: boolean;
};

export function TreatmentHoldProviderContactFields({sending}: Props) {
    const currentUser = useCurrentUser();
    const {setValue, getValues} = useFormContext<TreatmentHoldInput>();

    useEffect(() => {
        if (!currentUser) {
            return;
        }
        if (!getValues("providerContactName")) {
            setValue("providerContactName", `${currentUser.firstName ?? ""} ${currentUser.lastName ?? ""}`.trim());
        }
        if (!getValues("providerContactEmail") && currentUser.email) {
            setValue("providerContactEmail", currentUser.email);
        }
    }, [currentUser, getValues, setValue]);

    return (
        <div className="pt-2">
            <div className="font-bold pb-2">Provider Contact</div>
            <ModalTextAreaInput<TreatmentHoldInput>
                disabled={sending}
                field="providerContactName"
                label="Name"
                labelClassName="font-bold"
                labelPosition="left"
                rowsNum={1}
                maxLength={255}
                required={false}
            />
            <ModalTextAreaInput<TreatmentHoldInput>
                disabled={sending}
                field="providerContactEmail"
                label="Email"
                labelClassName="font-bold"
                labelPosition="left"
                rowsNum={1}
                maxLength={255}
                required={false}
            />
            <ModalTextAreaInput<TreatmentHoldInput>
                disabled={sending}
                field="providerContactPhone"
                label="Phone"
                labelClassName="font-bold"
                labelPosition="left"
                rowsNum={1}
                maxLength={50}
                required
                requiredMessage="Please enter a phone number"
                optionalRules={{
                    required: {value: true, message: "Please enter a phone number"},
                    validate: {
                        notEmpty: (v: string) =>
                            (v || "").trim().length > 0 || "Please enter a phone number",
                        maxLength: (v: string) =>
                            (v || "").length <= 50 || "Maximum length is 50 characters",
                        phoneFormat: (v: string) => {
                            if (!(v || "").trim()) {
                                return true;
                            }
                            const digits = String(v).replace(/\D/g, "");
                            if (digits.length > 10) {
                                return "Phone number must not exceed 10 digits.";
                            }
                            return digits.length >= 10 || "Please enter a valid phone number";
                        },
                    },
                }}
            />
        </div>
    );
}
